import * as React from "react";
import { useAuth } from "@/auth/AuthProvider";
import { SignInScreen } from "@/screens/SignInScreen";

/**
 * The gate in front of the shell.
 *
 * It renders the sign-in screen IN PLACE rather than redirecting to a /login
 * route, for two reasons. The URL the operator was on survives a session
 * expiring, so signing back in lands them where they were instead of on a
 * dashboard. And there is no /login route to leak into a bookmark or a browser
 * history that a colleague might open.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { signedIn, loading } = useAuth();

  // The boot call is in flight. Neither the shell nor the sign-in screen is the
  // right answer yet, and flashing one of them is how "am I signed in?" becomes
  // a question the operator asks twice a day.
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        <span className="sr-only">Loading</span>
        <span aria-hidden>…</span>
      </div>
    );
  }

  return signedIn ? <>{children}</> : <SignInScreen />;
}
